import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DotLoader } from '../../feedback/loader/dot-loader.component';
import { BaseModalComponent } from '../base-modal/base-modal.component';
import { ModalLayoutComponent } from '../base-modal/modal-layout/modal-layout.component';

@Component({
  selector: 'app-loader-modal',
  imports: [DotLoader, ModalLayoutComponent],
  templateUrl: './loader-modal.component.html',
  styleUrl: './loader-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoaderModalComponent extends BaseModalComponent<{ message: string }> {
  content = this.modaldata;
}
